export default "__VITE_ASSET__ca79b7dd__"